import {Box,  Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import GaugeChart from "react-gauge-chart";

import DataService from "../../../../../../Service";
import ChartLoader from "../ChartLoader";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  slaPieGraph: {
    width: "75%",
  },
}));

function SLAMetricsGraph(props) {

  const classes = useStyles();
  const {plainView}=props;
  const {id:organisationId} = props.organisationId;
  const [slaMatrixPercentage, setSlaMatrixPercentage] = useState(0);
  const [chartLoader, setChartLoader] = useState(true);

  const getAssignmentBySla = (organisationId) => {
    DataService.getDirectData("dashboards/sla_matrix" , {"organisation_id":organisationId}).then(
      (response) => {
        setSlaMatrixPercentage(response.sla_matrix);
        setChartLoader(false);
      }
    );
  };
  useEffect(()=>{
    getAssignmentBySla(organisationId);
    setChartLoader(true);
  },[organisationId])
  
  const MainStyle = {boxShadow:4,padding:1 }
  if(plainView){
    MainStyle.boxShadow = 0;
    MainStyle.padding = 0;
  }
  return (
    <Box width="100%">
          <Box {...MainStyle} style={{ borderRadius: "5px" }}>
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  style={{
                    height: "47px",
                    alignItems: "center",
                    display: "flex",
                    paddingLeft:"26px"
                  }}
                    fontWeight="fontWeightBold"
                > 
                    SLA metrics
                </Typography>
            <Box width={1} style={{ padding: "57px" }}>
              <Box width={1} className={classes.slaPieGraph}>
                {chartLoader ? (
                  <ChartLoader />
                ) : (
                  <AssignmentByGauge
                    assignmentByGauge={{
                      id: organisationId,
                      nrOfLevels: 100,
                      arcsLength: [0.4, 0.5, 0.1],
                      colors: ["#EC9706", "#636569", "#078f47"],
                      percent: slaMatrixPercentage / 100,
                      arcPadding: 0.02,
                      textColor: "#232323",
                    }}
                  />
                )}
              </Box>
            </Box>
          </Box>      
    </Box>
  );
}

export default SLAMetricsGraph;

const AssignmentByGauge = React.memo(
  (props) => (
    <GaugeChart
      key={Math.random()*10}
      id={props.assignmentByGauge.id}
      nrOfLevels={props.assignmentByGauge.nROfLevels}
      arcsLength={props.assignmentByGauge.arcsLength}
      colors={props.assignmentByGauge.colors}
      percent={props.assignmentByGauge.percent}
      arcPadding={props.assignmentByGauge.arcPadding}
      textColor={props.assignmentByGauge.textColor}
    />
  ),
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.assignmentByGauge) ===
      JSON.stringify(nextProps.assignmentByGauge)
    );
  }
);